import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { companyInfo } from '../mockData';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Home', id: 'home' },
    { label: 'About Us', id: 'about' },
    { label: 'Strengths', id: 'strengths' },
    { label: 'Infrastructure', id: 'infrastructure' },
    { label: 'Quality', id: 'quality' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <>
      {/* Main Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4">
          {/* Top Row - Navigation */}
          <div className="flex items-center justify-between py-3 border-b border-slate-200">
            {/* Desktop Navigation - Centered */}
            <nav className="hidden lg:flex items-center gap-8 flex-1 justify-center">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-slate-700 hover:text-blue-600 font-medium transition-colors relative group"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-300"></span>
                </button>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden lg:flex items-center">
              <button
                onClick={() => scrollToSection('enquiry')}
                className="px-5 py-2.5 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300 shadow-md hover:shadow-lg"
              >
                Quick Enquiry
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-slate-700 hover:text-blue-600 transition-colors ml-auto"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Bottom Row - Company Logo/Name Centered */}
          <div className="flex items-center justify-center py-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_sharad-enterprise/artifacts/9a2nmojc_title.jpg" 
              alt={companyInfo.name}
              className="h-32 w-auto cursor-pointer"
              onClick={() => scrollToSection('home')}
            />
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="lg:hidden pb-4 border-t border-slate-200 mt-2">
              <nav className="flex flex-col gap-3 pt-4">
                {navItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className="text-left px-4 py-2 text-slate-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors font-medium"
                  >
                    {item.label}
                  </button>
                ))}
                <div className="flex flex-col gap-2 px-4 pt-2">
                  <button
                    onClick={() => scrollToSection('enquiry')}
                    className="w-full px-5 py-2.5 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all"
                  >
                    Quick Enquiry
                  </button>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
